import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
  FaqPage,
  TermsAndConditionsPage,
  CCBPage,
  SessionPage,
  EmailInvalidPage,
  ErrorDefaultPage,
  EmailOtpPage,
  ProposalPage,
  TicketPage,
  ProposalConfirmedPage,
  LoadingPage,
  IdwallReprovedPage,
  IdwallTimeoutPage,
} from '@src/pages';
import { AnimatePresence } from 'framer-motion';

import { MuiProvider } from './config/theme/mui-provider';
import { GTMProvider } from './config/gtm';

type RoutesType = {
  path: string;
  element: React.ReactNode;
};

function App() {
  const routes: RoutesType[] = [
    { path: '/:proposal/proposal/:hash', element: <ProposalPage /> },
    {
      path: '/proposal/confirmed',
      element: <ProposalConfirmedPage />,
    },
    { path: '/email-validation', element: <EmailOtpPage /> },
    { path: '/loading', element: <LoadingPage /> },
    { path: '/faq', element: <FaqPage /> },
    { path: '/error', element: <ErrorDefaultPage /> },
    { path: '/error/session', element: <SessionPage /> },
    { path: '/error/email-invalid', element: <EmailInvalidPage /> },
    { path: '/error/reproved', element: <IdwallReprovedPage /> },
    { path: '/error/timeout', element: <IdwallTimeoutPage /> },
    {
      path: '/ccb',
      element: <CCBPage adoptLayoutExternalPublic={true} />,
    },
    { path: '/terms/ccb', element: <CCBPage /> },
    {
      path: '/termos-e-condicoes',
      element: <TermsAndConditionsPage adoptLayoutExternalPublic={true} />,
    },
    {
      path: '/terms/terms-and-conditions',
      element: <TermsAndConditionsPage />,
    },
    { path: '/ticket', element: <TicketPage /> },
    { path: '*', element: <ErrorDefaultPage /> },
  ];

  return (
    <GTMProvider>
      <AnimatePresence mode='wait'>
        <MuiProvider>
          <Router>
            <Routes>
              {routes.map((route) => (
                <Route
                  path={route.path}
                  element={route.element}
                  key={route.path}
                />
              ))}
            </Routes>
          </Router>
        </MuiProvider>
      </AnimatePresence>
    </GTMProvider>
  );
}

export default App;
